import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import axiosConfig from '../../../store/sagas/axiosConfig';
import { loginSuccess, logout, setLoaded } from '../../../store/slices/user';

const CustomAuthProvider = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && Date.parse(user.expiryDate) < new Date()) {
      dispatch(logout());
    } else if (user && user.accessToken) {
      axiosConfig.defaults.headers.Authorization = `Bearer ${user.accessToken}`;
      dispatch(loginSuccess({ token: user.accessToken, email: user.email }));
    } else {
      dispatch(setLoaded());
    }
  }, [dispatch]);

  return children || <></>;
};

CustomAuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CustomAuthProvider;
